<template>
  <div>
    <div>
      <button
        v-on:click="abrirModalcrear()"
        class="btn btn-primary mb-3 btn-sm"
      >
        <span class="svg-icon svg-icon-light svg-icon-1x"
          ><!--begin::Svg Icon | path:C:\wamp64\www\keenthemes\themes\metronic\theme\html\demo2\dist/../src/media/svg/icons\Communication\Add-user.svg--><svg
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            width="24px"
            height="24px"
            viewBox="0 0 24 24"
            version="1.1"
          >
            <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <polygon points="0 0 24 0 24 24 0 24" />
              <path
                d="M18,8 L16,8 C15.4477153,8 15,7.55228475 15,7 C15,6.44771525 15.4477153,6 16,6 L18,6 L18,4 C18,3.44771525 18.4477153,3 19,3 C19.5522847,3 20,3.44771525 20,4 L20,6 L22,6 C22.5522847,6 23,6.44771525 23,7 C23,7.55228475 22.5522847,8 22,8 L20,8 L20,10 C20,10.5522847 19.5522847,11 19,11 C18.4477153,11 18,10.5522847 18,10 L18,8 Z M9,11 C6.790861,11 5,9.209139 5,7 C5,4.790861 6.790861,3 9,3 C11.209139,3 13,4.790861 13,7 C13,9.209139 11.209139,11 9,11 Z"
                fill="#000000"
                fill-rule="nonzero"
                opacity="0.3"
              />
              <path
                d="M0.00065168429,20.1992055 C0.388258525,15.4265159 4.26191235,13 8.98334134,13 C13.7712164,13 17.7048837,15.2931929 17.9979143,20.2 C18.0095879,20.3954741 17.9979143,21 17.2466999,21 C13.541124,21 8.03472472,21 0.727502227,21 C0.476712155,21 -0.0204617505,20.45918 0.00065168429,20.1992055 Z"
                fill="#000000"
                fill-rule="nonzero"
              />
            </g></svg
          ><!--end::Svg Icon--></span
        >

        Nuevo Banco
      </button>
      <v-data-table
        :headers="headers"
        :items="bancos"
        :items-per-page="10"
        class="elevation-2 tabla-codebase theme--light"
        loading-text="Cargando... Espere Por favor"
        :footer-props="{
          showFirstLastPage: true,
          'items-per-page-text': 'Registros por página',
          'items-per-page-all-text': 'Todas',
        }"
      >
        <template v-slot:[`item.activo`]="item">
          <span
            :class="getColor(item.item.activo)"
            class="label label-md label-inline font-weight-bold"
          >
            {{ item.item.activo == true ? "Si" : "No" }}</span
          >
        </template>
        <template v-slot:[`item.nombreBanco`]="item">
          {{ capitalizar(item.item.nombreBanco) }}
        </template>

        <template v-slot:[`item.editar`]="item">
          <span
            class="btn btn-icon btn-light btn-hover-primary btn-sm"
            v-on:click="cargarEditarBanco(item.item)"
          >
            <span class="svg-icon svg-icon-md svg-icon-primary">
              <!--begin::Svg Icon | path:assets/media/svg/icons/Communication/Write.svg-->
              <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                width="24px"
                height="24px"
                viewBox="0 0 24 24"
                version="1.1"
              >
                <g
                  stroke="none"
                  stroke-width="1"
                  fill="none"
                  fill-rule="evenodd"
                >
                  <rect x="0" y="0" width="24" height="24"></rect>
                  <path
                    d="M12.2674799,18.2323597 L12.0084872,5.45852451 C12.0004303,5.06114792 12.1504154,4.6768183 12.4255037,4.38993949 L15.0030167,1.70195304 L17.5910752,4.40093695 C17.8599071,4.6812911 18.0095067,5.05499603 18.0083938,5.44341307 L17.9718262,18.2062508 C17.9694575,19.0329966 17.2985816,19.701953 16.4718324,19.701953 L13.7671717,19.701953 C12.9505952,19.701953 12.2840328,19.0487684 12.2674799,18.2323597 Z"
                    fill="#000000"
                    fill-rule="nonzero"
                    transform="translate(14.701953, 10.701953) rotate(-135.000000) translate(-14.701953, -10.701953)"
                  ></path>
                  <path
                    d="M12.9,2 C13.4522847,2 13.9,2.44771525 13.9,3 C13.9,3.55228475 13.4522847,4 12.9,4 L6,4 C4.8954305,4 4,4.8954305 4,6 L4,18 C4,19.1045695 4.8954305,20 6,20 L18,20 C19.1045695,20 20,19.1045695 20,18 L20,13 C20,12.4477153 20.4477153,12 21,12 C21.5522847,12 22,12.4477153 22,13 L22,18 C22,20.209139 20.209139,22 18,22 L6,22 C3.790861,22 2,20.209139 2,18 L2,6 C2,3.790861 3.790861,2 6,2 L12.9,2 Z"
                    fill="#000000"
                    fill-rule="nonzero"
                    opacity="0.3"
                  ></path>
                </g>
              </svg>
              <!--end::Svg Icon-->
            </span>
          </span>
        </template>
        <template v-slot:[`item.activar`]="item">
          <span
            class="svg-icon svg-icon-primary svg-icon-2x"
            v-if="item.item.activo == false"
            v-on:click="actualizarEstadoBanco(item.item)"
            ><svg
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              width="24px"
              height="24px"
              viewBox="0 0 24 24"
              version="1.1"
            >
              <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <rect x="0" y="0" width="24" height="24" />
                <circle fill="#000000" opacity="0.3" cx="12" cy="12" r="10" />
                <path
                  d="M16.7689447,7.81768175 C17.1457787,7.41393107 17.7785676,7.39211077 18.1823183,7.76894473 C18.5860689,8.1457787 18.6078892,8.77856757 18.2310553,9.18231825 L11.2310553,16.6823183 C10.8654446,17.0740439 10.2560456,17.107974 9.84920863,16.7592566 L6.34920863,13.7592566 C5.92988278,13.3998345 5.88132125,12.7685345 6.2407434,12.3492086 C6.60016555,11.9298828 7.23146553,11.8813212 7.65079137,12.2407434 L10.4229928,14.616916 L16.7689447,7.81768175 Z"
                  fill="#000000"
                  fill-rule="nonzero"
                />
              </g></svg
          ></span>

          <span
            class="svg-icon svg-icon-primary svg-icon-2x"
            v-if="item.item.activo"
            v-on:click="actualizarEstadoBanco(item.item)"
            ><svg
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              width="24px"
              height="24px"
              viewBox="0 0 24 24"
              version="1.1"
            >
              <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <rect x="0" y="0" width="24" height="24" />
                <circle fill="#000000" opacity="0.3" cx="12" cy="12" r="10" />
                <path
                  d="M12.0355339,10.6213203 L14.863961,7.79289322 C15.2544853,7.40236893 15.8876503,7.40236893 16.2781746,7.79289322 C16.6686989,8.18341751 16.6686989,8.81658249 16.2781746,9.20710678 L13.4497475,12.0355339 L16.2781746,14.863961 C16.6686989,15.2544853 16.6686989,15.8876503 16.2781746,16.2781746 C15.8876503,16.6686989 15.2544853,16.6686989 14.863961,16.2781746 L12.0355339,13.4497475 L9.20710678,16.2781746 C8.81658249,16.6686989 8.18341751,16.6686989 7.79289322,16.2781746 C7.40236893,15.8876503 7.40236893,15.2544853 7.79289322,14.863961 L10.6213203,12.0355339 L7.79289322,9.20710678 C7.40236893,8.81658249 7.40236893,8.18341751 7.79289322,7.79289322 C8.18341751,7.40236893 8.81658249,7.40236893 9.20710678,7.79289322 L12.0355339,10.6213203 Z"
                  fill="#000000"
                />
              </g></svg
            ><!--end::Svg Icon--></span
          >
        </template>
        <template v-slot:body.prepend>
          <tr>
            <td></td>
            <td>
              <v-text-field
                v-model="nombreBanco"
                type="text"
                label="Nombre Banco"
                prepend-inner-icon="mdi-account-box-multiple"
                outlined
                dense
              ></v-text-field>
            </td>
            <td>
              <v-text-field
                v-model="codigoSBIF"
                type="text"
                label="Codigo SBIF"
                prepend-inner-icon="mdi-account-box-multiple"
                outlined
                dense
              ></v-text-field>
            </td>
          </tr>
        </template>
      </v-data-table>
    </div>

    <b-modal no-close-on-backdrop id="modal-crear-banco" hide-footer>
      <b-form
        @show="resetModal"
        @hidden="resetModal"
        class="form-signin d-flex align-items-stretch flex-column"
        @submit.stop.prevent="onSubmit"
      >
        <div class="text-center mb-2">
          <img
            class="mb-2"
            src="media/logos/logo-contempora1.png"
            alt=""
            width="120"
          />
          <h3 class="mb-0">{{ formTitle }}</h3>
          <span>Completa el siguiente formulario</span>
        </div>

        <div
          role="alert"
          v-show="errors.length > 0"
          v-bind:class="{ show: errors.length }"
          class="alert alert-danger"
        >
          <div class="alert-text" v-for="(error, i) in errors" :key="i">
            {{ error }}
          </div>
        </div>

        <div class="form-label-group">
          <label for="example-input-3">Nombre Banco</label>

          <b-form-input
            maxlength="50"
            class="form-control"
            type="text"
            id="example-input-3"
            name="example-input-3"
            v-model="$v.form.nombreBanco.$model"
            :state="validateStateFull('nombreBanco')"
            aria-describedby="input-3-live-feedback"
          ></b-form-input>

          <b-form-invalid-feedback id="input-3-live-feedback">
            Nombre es requerido.
          </b-form-invalid-feedback>
        </div>

        <div class="form-label-group">
          <label for="example-input-4">Codigo SBIF</label>

          <b-form-input
            maxlength="50"
            class="form-control"
            type="text"
            id="example-input-4"
            name="example-input-4"
            v-model="$v.form.codigoSBIF.$model"
            :state="validateStateFull('codigoSBIF')"
            aria-describedby="input-4-live-feedback"
          ></b-form-input>

          <b-form-invalid-feedback id="input-4-live-feedback">
            Codigo SBIF es requerido.
          </b-form-invalid-feedback>
        </div>

        <button
          v-show="esEditarBanco == false"
          ref="btn_crear_banco"
          class="btn btn-primary align-self-center mt-2"
        >
          Crear
        </button>

        <button
          v-show="esEditarBanco"
          ref="btn_actualizar_banco"
          class="btn btn-primary align-self-center mt-2"
        >
          Actualizar
        </button>
      </b-form>
    </b-modal>
    <Loader
      v-bind:loading="activo"
      v-bind:text="modalText"
      v-bind:overlay="overlay"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
import {
  GET_BANCOS,
  GET_BANCO,
  UPDATE_BANCO,
  CREATE_BANCO,
  ACTUALIZAR_ESTADO_BANCO,
} from "@/core/services/store/banco.module";

import { validationMixin } from "vuelidate";
import {
  email,
  minLength,
  maxLength,
  required,
} from "vuelidate/lib/validators";
import DataTableWidget from "@/view/content/widgets/advance-table/DataTableUsuario.vue";
import moment from "moment";
import Loader from "@/view/content/Loader.vue";
import { rutEsValido, calculateDV } from "@/assets/js/rut.js";
moment.locale("es");

export default {
  mixins: [validationMixin],
  name: "bancos",
  components: {
    Loader,
  },
  data() {
    return {
      rutValido: false,
      nombreBanco: "",
      codigoSBIF: "",
      search: "",
      editedIndex: -1,
      activo: true,
      overlay: true,
      dialog: false,
      bancos: [],
      roles: [],
      errors: [],
      page: 1,
      itemsPerPage: 10,
      pages: 1,
      loading: true,
      esEditarBanco: false,
      tokenUsuario: null,
      modalText: "Cargando datos...",
      textDatos: "Datos cargados correctamente",
      textErrorDatos: "¡Error al cargar datos!",
      headers: [
        {
          text: "ID",
          align: "start",
          sortable: true,
          value: "bancoId",
          width: "10px",
        },
        {
          text: "Nombre",
          value: "nombreBanco",
          width: "200px",
          filter: (f) => {
            return (f + "")
              .toLowerCase()
              .includes(this["nombreBanco"].toLowerCase());
          },
        },
        {
          text: "Codigo SBIF",
          value: "codigoSBIF",
          width: "50px",
          filter: (f) => {
            return (f + "")
              .toLowerCase()
              .includes(this["codigoSBIF"].toLowerCase());
          },
        },
        { text: "Activo", value: "activo", width: "50px" },
        { text: "Editar", value: "editar", sortable: false, width: "60px" },
        { text: "Activar", value: "activar", sortable: false, width: "60px" },
      ],
      step2: false,
      form: {
        bancoId: "",
        nombreBanco: "",
        codigoSBIF: "",
      },
    };
  },
  validations: {
    form: {
      nombreBanco: {
        required,
        minLength: minLength(3),
      },
      codigoSBIF: {
        required,
        minLength: minLength(1),
      },
      bancoId: {},
    },
  },
  mounted() {
    // this.obtenerRoles();
    this.cargarBancos();
  },
  methods: {
    abrirModalcrear() {
      this.editedIndex = -1;
      (this.esEditarBanco = false), this.resetModal();
      this.resetForm();
      this.$bvModal.show("modal-crear-banco");
      this.dialog = true;
    },
    cargarEditarBanco(item) {
      this.editedIndex = this.bancos.indexOf(item);
      //console.log((item);
      this.esEditarBanco = true;
      this.$v.form.bancoId.$model = item.bancoId;
      this.$v.form.nombreBanco.$model = item.nombreBanco;
      this.$v.form.codigoSBIF.$model = item.codigoSBIF;

      this.dialog = true;
      this.$bvModal.show("modal-crear-banco");
    },
    actualizarBanco() {
      const bancoId = parseInt(this.$v.form.bancoId.$model);
      const nombreBanco = this.$v.form.nombreBanco.$model;
      const codigoSBIF = parseInt(this.$v.form.codigoSBIF.$model);

      const submitButton = this.$refs["btn_actualizar_banco"];
      submitButton.classList.add("spinner", "spinner-light", "spinner-right");

      this.$store
        .dispatch(UPDATE_BANCO, {
          bancoId,
          nombreBanco,
          codigoSBIF,
        })
        .then(() => {
          this.cargarBancos();
          this.dialog = false;
          this.$bvModal.hide("modal-crear-banco");
          this.makeToast(
            false,
            "El banco se ha actualizado correctamente!!!",
            "Banco Actuzalizado"
          );
          submitButton.classList.remove(
            "spinner",
            "spinner-light",
            "spinner-right"
          );
        })
        .catch(({ response }) => {
          submitButton.classList.remove(
            "spinner",
            "spinner-light",
            "spinner-right"
          );
        });
    },
    makeToast(append = false, texto, titulo) {
      this.$bvToast.toast(texto, {
        title: titulo,
        autoHideDelay: 5000,
        variant: "success",
        toaster: "b-toaster-top-right",
        appendToast: append,
      });
    },
    getColor(valor) {
      if (valor == "ADMINISTRADOR") return "label-light-primary";
      else if (valor == "CAJERO") return "label-light-success";
      else if (valor == "EJECUTIVO") return "label-light-info";
      else if (valor == true) return "label-light-success";
      else if (valor == false) return "label-light-danger";
      else return "label-light-success";
    },
    capitalizar(valor) {
      let texto = valor.toLowerCase();
      return texto.charAt(0).toUpperCase() + texto.slice(1);
    },
    formatDate(value) {
      const duration = moment(value).format("DD/MM/yyyy");
      return `${duration}`;
    },
    cargarBancos() {
      this.$store
        .dispatch(GET_BANCOS)
        .then((data) => {
          this.bancos = data;
          this.loading = true;
          this.makeToast(false, "Datos Cargados", "Aviso", "success");
        })
        .catch(({ response }) => {
          this.makeToast(false, "Datos No Cargados", "Aviso", "danger");
        });
    },
    mensajeFalloLoad() {
      this.activo = false;
      this.overlay = false;
      this.makeToast(false, this.textErrorDatos, "Error", "danger");
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    validateStateFull(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    resetModal() {
      this.$v.form.nombreBanco.$model = null;
      this.$v.form.codigoSBIF.$model = null;
    },
    resetForm() {
      this.form = {
        nombreBanco: null,
        codigoSBIF: null,
      };

      this.$nextTick(() => {
        this.$v.$reset();
      });
    },
    onSubmit() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }

      if (this.esEditarBanco) {
        this.actualizarBanco();
      } else {
        this.crearBanco();
      }
    },
    crearBanco() {
      this.esEditarBanco = false;

      const nombreBanco = this.$v.form.nombreBanco.$model;
      const codigoSBIF = parseInt(this.$v.form.codigoSBIF.$model);

      const submitButton = this.$refs["btn_crear_banco"];
      submitButton.classList.add("spinner", "spinner-light", "spinner-right");

      this.$store
        .dispatch(CREATE_BANCO, {
          nombreBanco,
          codigoSBIF,
        })
        .then(() => {
          this.cargarBancos();
          this.dialog = false;
          this.$bvModal.hide("modal-crear-banco");
          this.makeToast(
            false,
            "El el banco se ha creado correctamente!!!",
            "Banco Creado"
          );
        });

      submitButton.classList.remove(
        "spinner",
        "spinner-light",
        "spinner-right"
      );
    },
    actualizarEstadoBanco(item) {
      const activo = item.activo == true ? false : true;
      const bancoId = item.bancoId;

      // send login request
      this.$store
        .dispatch(ACTUALIZAR_ESTADO_BANCO, {
          bancoId,
          activo,
        })
        .then(() => {
          this.cargarBancos();
          this.makeToast(
            false,
            "El banco se ha actualizado correctamente!!!",
            "Banco Actuzalizado"
          );
        });
    },
    validarNombres(nombres) {
      let char = String.fromCharCode(nombres.keyCode);
      if (/^[A-Za-z' ']+$/.test(char)) return true;
      else nombres.preventDefault();
    },
    validarAlias(alias) {
      let char = String.fromCharCode(alias.keyCode);
      if (/^[A-Za-z]+$/.test(char)) return true;
      else alias.preventDefault();
    },
    validarTelefono(telefono) {
      let char = String.fromCharCode(telefono.keyCode);
      if (/^[0-9]+$/.test(char)) return true;
      else telefono.preventDefault();
    },
  },

  filters: {
    formatDate(value) {
      const duration = moment(value).format("DD/MM/yyyy");
      return `${duration}`;
    },
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Crear Nuevo Banco" : "Editar Banco";
    },
    ...mapState({
      errors: (state) => state.errors,
      // user: state => state.auth.user,
    }),
  },
};
</script>
<style>
.v-data-table-header th span {
  font-size: 12px;
}
#modal-crear-usuario .modal-header {
  border: 0 !important;
}

.tabla-codebase td {
  padding: 0.75rem !important;
  border-bottom: 1px solid #ecf0f3 !important;
}
.tabla-codebase th {
  border-bottom: 1px solid #ecf0f3 !important;
}
.form-signin {
  border: 0 !important;
  box-shadow: none !important;
  border-radius: 0px;
}
.b-form-datepicker {
  min-width: 130px;
}
.b-form-datepicker label {
  padding-bottom: 3px !important;
  padding-top: 6px;
  text-transform: none;
  white-space: nowrap !important;
  font-size: 1rem !important;
}
.b-form-datepicker .btn:not(:disabled):not(.disabled) {
  cursor: pointer;
  padding: 10px 5px;
}
.d-content-full {
  width: 100%;
}
.v-dialog {
  border-radius: 24px;
}
/* .v-data-footer {
    display: flex !important;
    flex-wrap: wrap !important;
    justify-content: flex-end !important;
    align-items: center !important;
    font-size: .75rem !important;
    padding: 0 8px !important;
}

.v-data-footer__select {
    display: flex !important;
    align-items: center !important;
    flex: 0 0 0 !important;
    justify-content: flex-end !important;
    white-space: nowrap !important;
} */

/* .svg-icon.svg-icon-md svg {
    height: 1.5rem !important;
    width: 1.5rem !important;
}

.btn-sm, .btn-group-sm > .btn {
    padding: 0.55rem 0.75rem !important;
    font-size: 0.925rem !important;
    line-height: 1.35 !important;
    border-radius: 0.42rem !important;
}

.btn.btn-light {
    color: #80808F !important;
    background-color: #F3F6F9 !important;
    border-color: #F3F6F9 !important;
} */
#rutUsuario,
.rut {
  width: 86%;
  float: left;
  margin-right: 6px;
}

#rutUsuarioDv,
.rutDv {
  width: 12%;
}
</style>
